export default "__VITE_ASSET__175a3044__"